module.exports = __webpack_public_path__ + "static/media/m_hairstyle_quiff_front.d0b1b029.png";